// This JavaScript file is created by Cision for our sharegraph module.
// This should be combined with sharegraph.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.sharegraph = !cision.websolution.settings.sharegraph ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.sharegraph.accessKey;

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var buildChart = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your sharegraph access key.");
            return;
        }

        var url = generateUrl('Share/' + accessKey);

        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            data: {
                startDate: settings.dateToStartFrom,
                endDate: settings.dateToEnd,
                quoteType: settings.typeOfChart
            }
        })
            .done(function (shareData) {

                var seriesList = [],
                    seriesVolumeList = [],
                    isEndOfDay = (settings.typeOfChart == 'EndOfDay');

                for (var ix = 0; ix < shareData.Instruments.length; ix++) {
                    var objInstrument = shareData.Instruments[ix],
                        isVisible = false,
                        isMain = false;

                    objInstrument.MarketPlace = objInstrument.MarketPlace.trim();

                    // Check if this is a main instrument
                    $.each(settings.mainInstruments, function (qix, objMainInstrument) {
                        if (objInstrument.TickerSymbol === objMainInstrument.symbol && objInstrument.MarketPlace === objMainInstrument.marketPlace) {
                            isVisible = true;
                            isMain = true;
                            if (objMainInstrument.isHidden === true) {
                                isVisible = false;
                            }
                        }
                    });

                    // This used in finding which series we are dealing with (in show/hide checkboxes)
                    objInstrument.UniqueKey = objInstrument.TickerSymbol + objInstrument.MarketPlace + objInstrument.TradeCurrency;

                    var points = [],
                        pointsEffectiveYield = [],
                        pointsVolume = [];

                    $.each(objInstrument.Quotes, function (qix, objQuote) {
                        if (settings.typeOfChart == 'EndOfDay') {
                            /* Remove Time*/
                            objQuote.QuoteTime = moment(objQuote.QuoteTime).format('YYYY-MM-DD') + 'T00:00:00Z';
                        } else {
                            /* Remove Seconds */
                            objQuote.QuoteTime = moment(objQuote.QuoteTime).format('YYYY-MM-DD[T]HH:mm') + ':00Z';
                        }
                        objQuote.DeltaPercentage = (objQuote.DeltaPercentage * 100).toFixed(2);
                        var patt = new RegExp("-");
                        var res = patt.test(objQuote.DeltaPercentage);
                        if (!res) {
                            objQuote.DeltaPercentage = '+' + objQuote.DeltaPercentage;
                        }
                        var quoteUnixTime = moment(objQuote.QuoteTime).format('X') * 1000;
                        points.push({
                            x: moment(objQuote.QuoteTime).format('X') * 1000,
                            y: objQuote.Price,
                            extras: objQuote.DeltaPercentage
                        });

                        if (isMain) {
                            pointsVolume.push({
                                x: quoteUnixTime,
                                y: objQuote.Quantity
                            });
                        }
                    });

                    seriesList.push({
                        id: objInstrument.UniqueKey,
                        name: objInstrument.TickerSymbol,
                        data: points,
                        visible: isVisible,
                        color: getPreferredColor(objInstrument.UniqueKey),
                        tooltip: {
                            valueDecimals: 2,
                            pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: ' + objInstrument.TradeCurrency + ' <b>{point.y}</b> ({point.extras}%)</span><br/> '
                        },

                        // Extra data
                        objOriginal: objInstrument
                    });

                    // Volume
                    if (settings.showVolume && isMain && pointsVolume && pointsVolume.length > 0) {
                        seriesVolumeList.push({
                            id: objInstrument.UniqueKey + 'VOLUME',
                            name: objInstrument.TickerSymbol + ' [VOLUME]',
                            data: pointsVolume,
                            visible: isVisible,
                            color: getPreferredColor(objInstrument.UniqueKey + 'VOLUME'),
                            type: 'column',
                            yAxis: 1,
                            tooltip: {
                                valueDecimals: 2
                            },

                            // Extra data
                            objOriginal: objInstrument
                        });
                    }

                    if (objInstrument.EffectiveYields && objInstrument.EffectiveYields.length > 0) {
                        // Process Effective Yield
                        var objInstrumentEffectiveYield = {
                            TickerName: objInstrument.TickerName + '/' + objInstrument.MarketPlace + ' [TR]',
                            TickerSymbol: objInstrument.TickerSymbol,
                            MarketPlace: objInstrument.MarketPlace,
                            TradeCurrency: objInstrument.TradeCurrency,
                            TickerType: 'EFFECTIVEYIELD',
                            UniqueKey: objInstrument.UniqueKey + settings.effectiveYieldSuffix,
                            Quotes: objInstrument.EffectiveYields
                        };

                        pointsEffectiveYield = [];
                        var objEffectiveYieldFirst = objInstrument.EffectiveYields[0];
                        $.each(objInstrument.EffectiveYields, function (eyix, objEffectiveYield) {
                            pointsEffectiveYield.push({
                                x: moment(objEffectiveYield.ObsDate).format('X') * 1000,
                                x1: objEffectiveYield.ObsDate,
                                y: objEffectiveYield.LastAdjReInv * objEffectiveYieldFirst.LastAdj / objEffectiveYieldFirst.LastAdjReInv
                            });
                        });

                        seriesList.push({
                            id: objInstrumentEffectiveYield.UniqueKey,
                            name: objInstrumentEffectiveYield.TickerName,
                            data: pointsEffectiveYield,
                            visible: false,
                            color: getPreferredColor(objInstrumentEffectiveYield.UniqueKey),
                            tooltip: {
                                valueDecimals: 2
                            },
                            zIndex: -1,

                            // Extra data
                            objOriginal: objInstrumentEffectiveYield
                        });
                    }
                }

                seriesList = seriesList.concat(seriesVolumeList);

                var objTitle = {
                    text: settings.chartTitle
                };

                var objPlotOptions = {
                    series: {
                        turboThreshold: 100000,
                        compare: settings.chartComparison,
                        lineWidth: settings.lineWidth

                    }
                };

                var objExporting = {
                    enabled: false,
                    sourceHeight: $("#container").height(),
                    sourceWidth: $("#container").width()
            };

                var objScrollbar = {
                    enabled: false,
                    barBackgroundColor: settings.barBackgroundColor,
                    barBorderRadius: 7,
                    barBorderWidth: 0,
                    buttonBackgroundColor: settings.buttonBackgroundColor,
                    buttonBorderWidth: 0,
                    buttonArrowColor: settings.buttonArrowColor,
                    buttonBorderRadius: 7,
                    rifleColor: settings.rifleColor,
                    trackBackgroundColor: settings.trackBackgroundColor,
                    trackBorderWidth: 1,
                    trackBorderColor: settings.trackBorderColor,
                    trackBorderRadius: 7
                };
                var objLegend = {
                    enabled: false,
                    shadow: true,
                    align: 'right',
                    backgroundColor: 'white',
                    borderColor: 'black',
                    borderWidth: 2,
                    layout: 'vertical',
                    verticalAlign: 'top',
                    x: 0,
                    y: 100
                };

                //
                var objYAxis = {
                    minPadding: 0.2,
                    maxPadding: 0.2,
                    opposite: false,
                    offset: -38,
                    title: {
                        text: '',
                        margin: 8
                    }
                };

                if (settings.showVolume) {
                    objYAxis = [{
                        height: settings.yAxisSize.share.height +40,
                        width: settings.yAxisSize.share.width,
                        offset: -38,
                        opposite: false
                    }, {
                        top: settings.yAxisSize.volume.top,
                        height: settings.yAxisSize.volume.height,
                        width: settings.yAxisSize.volume.width,
                        offset: -2,
                        opposite: false
                    }];
                }

                var objRangeSelector = {
                    enabled: false,
                    buttons: [],
                    inputStyle: {
                        color: settings.rangeSelectorInputStyleColor
                    },
                    labelStyle: {
                        color: settings.rangeSelectorLabelStyleColor
                    },
                    inputEnabled: true,
                    inputDateFormat: "%Y-%m-%d",
                    inputEditDateFormat: "%Y-%m-%d",
                    inputDateParser: function (value) {
                        value = value.split('-');
                        return Date.UTC(
                            parseInt(value[0]),
                            parseInt(value[1]) - 1,
                            parseInt(value[2])
                        );
                    }
                };

                Highcharts.setOptions({
                    lang: {
                        rangeSelectorZoom: '',
                        contextButtonTitle: cision.websolution.texts[settings.uiLanguage].TextDownload || 'Download',
                        months: cision.websolution.texts[settings.uiLanguage].calendarTexts['months'],
                        weekdays: cision.websolution.texts[settings.uiLanguage].calendarTexts['weekdays'],
                        shortMonths: cision.websolution.texts[settings.uiLanguage].calendarTexts['shortMonths'],
                        rangeSelectorFrom: cision.websolution.texts[settings.uiLanguage].calendarTexts['rangeSelectorFrom'],
                        rangeSelectorTo: cision.websolution.texts[settings.uiLanguage].calendarTexts['rangeSelectorTo'],
                        downloadJPEG: cision.websolution.texts[settings.uiLanguage].calendarTexts['downloadJPEG'],
                        downloadPDF: cision.websolution.texts[settings.uiLanguage].calendarTexts['downloadPDF'],
                        downloadPNG: cision.websolution.texts[settings.uiLanguage].calendarTexts['downloadPNG'],
                        downloadSVG: cision.websolution.texts[settings.uiLanguage].calendarTexts['downloadSVG'],
                        printChart: cision.websolution.texts[settings.uiLanguage].calendarTexts['printChart']
                    }
                });

                var objChart = new Highcharts.StockChart({
                    chart: {
                        renderTo: settings.chartContainerId,
                        defaultSeriesType: settings.defaultSeriesType,
                        plotBackgroundColor: settings.plotBackgroundColor,
                        plotBorderWidth: settings.plotBorderWidth,
                        plotBackgroundImage: settings.backgroundImage
                    },

                    title: objTitle,
                    xAxis: {
                        type: 'datetime',
                        gridLineWidth: settings.gridLineWidth
                    },
                    yAxis: objYAxis,
                    plotOptions: objPlotOptions,
                    rangeSelector: objRangeSelector,
                    scrollbar: objScrollbar,
                    legend: objLegend,

                    exporting: objExporting,
                    navigator: {
                        maskFill: 'rgba(50, 50, 50, 0.2)',
                        enabled: settings.isMiniShareGraph ? false : settings.enableNavigator,
                        series: {
                            color: settings.navigatorColor,
                            lineColor: settings.navigatorLineColor
                        }
                    },
                    credits: {
                        //'Latest change: '
                        text: netr.string.translate('cision.dataDelayed')
                        // text: netr.string.translate('cision.latestChange') + ': ' + shareData.LatestChange + ' Source Cision/Millistream'
                    },

                    series: seriesList
                });

                if (settings.enableReleasesOnIntraday == true || settings.typeOfChart == 'EndOfDay') {
                    $.ajax({
                        type: "GET",
                        url: url + '/Releases',
                        dataType: "json",
                        timeout: 10000,

                        data: {
                            startDate: settings.dateToStartFrom
                        }
                    })
                        .done(function (releaseData) {
                            showReleasesOnChart(objChart, releaseData.Releases);
                        });
                }

                if (options.success)
                    options.success();
            });
    };


    function showReleasesOnChart(objChart, releasePackageList) {
        $.each(releasePackageList, function (idxIns, objReleasePackage) {

            var releaseTitle = 'PRM';
            var seriesId = '_____';
            var seriesShape = 'squarepin';
            var isVisible = false;



            // This used in finding which series we are dealing with (in show/hide checkboxes)
            objReleasePackage.UniqueKey = objReleasePackage.Name;

            // Find out which series to attach it onto
            $.each(settings.releasesOnSeries, function (idx, objSetting) {
                if (objReleasePackage.Name == objSetting.packageName) {
                    // Found
                    seriesId = objSetting.symbol + objSetting.marketPlace + objSetting.currency;
                    seriesShape = objSetting.shape;
                    releaseTitle = objSetting.title;
                    isVisible = (objSetting.visible ? true : false);
                }
            });


            var seriesData = [];
            $.each(objReleasePackage.Releases, function (idxQuote, objRelease) {
                objRelease.PublishDateFormatted = moment(objRelease.PublishDate).locale(settings.uiLanguage).format();

                seriesData.push({
                    x: moment(objRelease.PublishDate).format('X') * 1000,
                    title: releaseTitle,
                    text: objRelease.Title,
                    Release: objRelease
                });
            });
            seriesData = seriesData.sort(function (a, b) {
                var res = a.x - b.x;
                if (res == 0)
                    return res;
                return res < 0 ? -1 : 1;
            });

            // Add Releases to Graph
            var objChartSeries = {
                id: objReleasePackage.Name,
                type: 'flags',
                onSeries: seriesId,
                shape: seriesShape,
                visible: isVisible,
                height: settings.shapeHeight,
                width: settings.shapeWidth,
                fillColor: settings.shapeColor,
                color: settings.shapeOutlineColor,
                style: { color: settings.shapeTextColor },
                name: objReleasePackage.Name,
                data: seriesData,

                // Extra data
                objOriginal: objReleasePackage
            };


            if (settings.showReleaseLink) {
                var releaseUrl = '{point.Release.CwUrl}';

                if (settings.releaseLinkFormatter && settings.releaseLinkFormatter !== 'CISIONWIRE') {
                    releaseUrl = settings.releaseLinkFormatter + '{point.Release.Id}';
                }

                objChartSeries.tooltip = {
                    headerFormat: '<div><small>{point.key}</small></div><br/>',
                    pointFormat: '<a style="color: blue" href="' + releaseUrl + '" target="_blank">{point.Release.Title}</a>'
                };
            }

            objChart.addSeries(objChartSeries);
        });
    }

    var setInstrumentVisibility = function (uniqueKey, makeVisible) {

        var objChart = $('#' + settings.chartContainerId).highcharts();

        $.each(objChart.series, function (idx, objSerie) {

            var objCurrentInstrument = objSerie.userOptions.objOriginal; /* the original object is attached above */

            if (objCurrentInstrument && objCurrentInstrument.UniqueKey == uniqueKey) {
                objSerie.setVisible(makeVisible);
            }
        });
    };

    var getPreferredColor = function (uniqueKey) {
        var color = null;
        try {
            $.each(settings.instrumentColors, function (idx, objInstrument) {

                // Is inst listed
                if (objInstrument.uniqueKey == uniqueKey) {
                    color = objInstrument.preferredColor;
                }
            });
        } catch (e) {

        }

        return color;
    };

    return {
        render: buildChart,
        setVisibility: setInstrumentVisibility
    };
}(jQuery);